// extracted by mini-css-extract-plugin
module.exports = {"QAndA":"questionsAndAnswers_QAndA__oRKLq"};